import contract from '@mailobj-browser/front/js/contracts/contract.js'
import global from './global/global.js'
import header from './header/header.js'
import rte from './rte/rte.js'
import attach from './attach/attach.js'
import adbook from './adbook/adbook.js'

export default contract({
  adbook,
  attach,
  global,
  header,
  rte,
})